import React, { useEffect, useState } from 'react';
import default_listing_image from 'default_listing_image.svg';
import Slider from 'react-slick';
import useWindowSize from '../hooks/useWindowSize';
import SliderArrow from './SliderArrow';

export default function ListingImagesSlider({
  featuredImage,
  additionalImages,
}) {
  const { width: windowWidth } = useWindowSize();

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const container = document.querySelector('.slick-list');
    const wrapper = document.querySelector('.page-content-image-container');
    const containerWidth = container.offsetWidth;
    const wrapperHeight = wrapper.offsetHeight;

    if (
      dimensions.width !== containerWidth ||
      dimensions.height !== wrapperHeight
    ) {
      // setDimensions({ width: containerWidth, height: wrapperHeight });
      setDimensions({ width: containerWidth });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isMobile = windowWidth <= 768;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    variableWidth: true,
    centerMode: true,
    arrows: !isMobile,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'custom-slick-dots',
    prevArrow: <SliderArrow type="instagram" direction="prev" />,
    nextArrow: <SliderArrow type="instagram" direction="next" />,
  };

  return (
    <Slider {...settings}>
      <section className="listing-image-wrapper">
        <img
          style={{ ...dimensions }}
          data-src={featuredImage}
          className="lazyload"
          alt=""
          title=""
        />
        <div className="rental-slider-overlay" />
      </section>
      {additionalImages.map((image, index) =>
        image ? (
          <section key={index} className="listing-image-wrapper">
            <img
              style={{ ...dimensions }}
              key={index}
              data-src={image}
              className={`lazyload ${!image ? 'default' : ''}`}
              alt=""
              title=""
            />
          </section>
        ) : (
          <section key={index} className="listing-image-wrapper">
            <img
              style={{ ...dimensions }}
              data-src={default_listing_image}
              className={`lazyload ${!image ? 'default' : ''}`}
              alt=""
              title=""
            />
          </section>
        )
      )}
    </Slider>
  );
}
